import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const InfoPageStyled = styled(IonPage)`
  &.info ion-header {
    background: #177590;

    & button {
      color: #ffffff;
    }
  }

  &.info ion-toolbar {
    --background: #177590;
  }

  &.info ion-content {
    --background: #177590;
  }

  &.info ion-progress-bar {
    &::part(track) {
      background: #e8ecf2;
    }

    &::part(progress) {
      background: #21abd2;
    }
  }
`;

export const InfoWrapper = styled.div`
  color: #ffffff;

  &.white {
    color: #1d201f;
  }

  h1 {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 10px;
  }

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 20px;
  }

  ul {
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    margin: 0;
    padding-left: 20px;
  }

  h3 {
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: #90d5e8;
  }

  &.white h3 {
    color: #1d201f;
  }

  & .ql-align-center {
    text-align: center;
  }

  & .ql-align-right {
    text-align: right;
  }

  & .ql-align-justify {
    text-align: justify;
  }

  & .ql-size-small {
    font-size: 10px;
    line-height: 14px;
    color: #90d5e8;
    display: block;
  }

  &.white .ql-size-small {
    color: #1d201f;
  }

  ol {
    list-style: none;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    margin: 30px 0 30px 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 10px;

    li {
      display: flex;
      align-items: center;
      column-gap: 10px;
    }

    li::before {
      content: url('/checkmark-circle.svg');
      width: 30px;
      height: 30px;
    }
  }

  &.animated-list ol,
  &.animated-list li {
    & li {
      position: relative;
      opacity: 0;
      transition: opacity 2s;
    }
  }
`;

export const InfoSliderWrapper = styled.div`
  margin-bottom: 30px;
`;

export const LoadParamsText = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #ffffff;
  opacity: 0;
  transition: opacity 2s;

  &.loaded {
    opacity: 1;
  }
`;
